export default __webpack_public_path__ + "static/media/CopyIcon2.257b63ae.svg";